import { z } from 'zod';

export type CreateCameraPayload = z.input<typeof createCameraPayloadSchema>;
export type CreateCameraPayloadDTO = z.output<typeof createCameraPayloadSchema>;

export const createCameraPayloadSchema = z.object({
  name: z.string().trim().min(1),
  type: z.enum(['labpano', 'static']),
  vendorId: z.string(),
});
